/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Edit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Update the configuration for this private model." |
*
* @param {Private_Models_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_edit_description = /** @type {((inputs?: Private_Models_Edit_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Edit_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren Sie die Konfiguration für dieses private Modell.")
	return /** @type {LocalizedString} */ ("Update the configuration for this private model.")
});